enum BillStatusEnum {
	OPEN = 'Aberto',
	IN_NEGOTIATION = 'Em Negociação',
	EXPIRED = 'Vencido',
	PAID = 'Pago',
}

const BILL_STATUS: Record<BillStatusEnum, string> = {
	[BillStatusEnum.OPEN]: 'Em aberto',
	[BillStatusEnum.IN_NEGOTIATION]: 'Em negociação',
	[BillStatusEnum.EXPIRED]: 'Vencido',
	[BillStatusEnum.PAID]: 'Pago',
};

export {BillStatusEnum, BILL_STATUS};
